import { setAllMounted, useMountedCount, useOpenCount } from './sections.js';

/**
 * Put the whole panel away, or bring it all back.
 *
 * ONE CONTROL, NOT TWO. Two buttons side by side in a 320px column is a button bar, and a button bar
 * directly under the panel's own heading is the "second title" this must not become. It names the
 * OUTCOME rather than the state — the opposite of what `ThemeToggle` argues for itself, and for a
 * stated reason: the theme control is the only thing on screen that says which theme is in force, so
 * it has to say it, whereas here the sections themselves say which of them are open.
 *
 * IT TAKES ITSELF AWAY BELOW THREE SECTIONS. On the root-selected pane, on a phase with no panel yet,
 * or on any short panel there is nothing worth a control — and disappearing is how it avoids being
 * chrome that outweighs what it acts on. Deciding that here rather than at the call site means no
 * caller has to know which panel is showing.
 *
 * NOT `expand-all`. `App.tsx:1393` has owned that testid since P1 for the CHART's branches, and the
 * end-to-end run clicks it inside `openProject`. A second element with the same testid is the
 * duplicated-selector failure the side panel's own comment warns about, and two controls 200px apart
 * both saying "Expand all" and meaning different things is the product version of the same fault.
 * Hence the word "sections" in both the id and the label.
 */
export function SectionToolbar(): JSX.Element | null {
  const total = useMountedCount();
  const open = useOpenCount();
  if (total < 3) return null;
  const anyOpen = open > 0;
  return (
    <div className="panel-tools">
      <button
        className="linkish"
        data-testid="panel-sections-toggle-all"
        /* Read by the end-to-end check that "collapse all" acted on the panel and not on the map. */
        data-open-count={open}
        onClick={() => setAllMounted(!anyOpen)}
      >
        {anyOpen ? `Collapse all sections (${open})` : 'Expand all sections'}
      </button>
    </div>
  );
}
